import React from "react";
import close from "../../../assets/images/model/close.svg";
import filePlus from "../../../assets/images/model/upload_arrow.svg";
const UploadImage = ({ setSelectedMediaType, setSelectedUploadingImag }) => {
  // const [uploadLoadingBook, setUploadLoadingBook] = useState(false);

  return (
    <div>
      <div
        className="modal custom_background custom_modal_create"
        id="upload_book"
        style={{ display: "block" }}
        tabIndex="-1"
        aria-labelledby="upload_bookLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button
                onClick={() => {
                  setSelectedMediaType(false);
                  setSelectedUploadingImag(false);
                }}
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <img src={close} alt="close" />
              </button>
            </div>
            <div className="modal-body-cre">
              <h4>add image</h4>
              <p>
                Drag and drop an image file from your computer. Add attribution
                and accessibility options (like alt text) in the next step.
              </p>
              <form action="" className="upload_book">
                <div className="upload_book_inner my-40 mb-0">
                  <div className="drag_and_drop_box" htmlFor="Drag-file">
                    <div className="upload_content">
                      <div className="icon-create mb-24">
                        <img src={filePlus} alt="upload" />
                      </div>
                      <div className="deflat_content">
                        <h6 className="f-size-18 theme__primary__text">
                          <span
                            onClick={() => {
                              setSelectedMediaType(false);
                              setSelectedUploadingImag(true);
                            }}
                          >
                            Drag and drop file, or{" "}
                          </span>
                          <a href="">
                            {" "}
                            <input type="file" id="Drag-file" /> Browse{" "}
                          </a>
                        </h6>
                        <p>Supports png or jpeg files | Max size 20mb</p>
                      </div>
                      <div
                        className="file_upload_content"
                        style={{ display: "none" }}
                      >
                        <p>
                          Spanish_book_101.pdf
                          <a href="">
                            <img src={close} alt="close" />
                          </a>
                        </p>
                      </div>
                    </div>
                    {/* <input type="file" id="Drag-file" /> */}
                  </div>
                  {/*  <div className="error_text error-create">
                    Oops, that file is too large to upload. Max file size is
                    1GB. Please try again.
                  </div> */}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadImage;
